import React, { useEffect, useState } from 'react';
import { useLocation,useHistory } from 'react-router-dom';
import './Live.css';
import { FaVoteYea } from "react-icons/fa";
import { FaPowerOff } from 'react-icons/fa';
import { FaYoutube } from "react-icons/fa";
import {getTransmision} from '../services/transmision'

export default function Transmision() {
  const [link, setLink] = useState("https://www.youtube.com/embed/knw5Z1Ma5TI?si=VoheGAeFHUwTFT3C");
  const { width } = useWindowDimensions();
  const location = useLocation();
  let history = useHistory(); 

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }


  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  
    useEffect(()=>{
      getTransmision().then(response => {
        setLink(response.body);      
      })
    },[])

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
  
  

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);


    }, []);
  
    return windowDimensions;
  }


  let redirectVote = () =>{
    history.push("/campana");
  }
    
    return(
        <div>
        <div className='wrap header'>
                <div className='logoContainer'>
                {width<700?( 
                    <div>
                      <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo-no" alt="Guadalupana"></img>
                    </div>
                  ):(
                    <div>
                      <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo" alt="Guadalupana"></img>
                    </div>
                  )
                }
                </div>
            </div>
            <center >
            <br/>
            <div className='tittle-youtube'>Bienvenido, para visualizar la transmisión en vivo presiona el botón <FaYoutube className='icono-youtube'/></div>
            </center>
         <div className="video-responsive">
          <iframe
            width="850"
            height="480"
            src={link}
            title="YouTube video player" 
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
          </iframe> 
         </div> 
        </div>
    )
}

